// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__lm5Qc","buttons":"Footer_buttons__1AqjV"};